let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e0E8p")).then(() => parcelRequire('1N8wK'));